import {useRouter} from 'next/router';
import {useCallback, useMemo} from 'react';
import {APP_ROUTES_KEYS, PRODUCT_BASE_ROUTE} from '../../constants';
import {IQuery, TProductRoutes, TRouteData, TRouteFn} from '../../types';
import {urlToRouteConverter} from '../../helpers';

export const useProductRoutes = (): TRouteData<TProductRoutes> => {
    const {push} = useRouter();

    const redirect = useCallback(
        (fn: TRouteFn) => (query?: IQuery) => {
            const url = fn(query);
            push(url);
        },
        [push],
    );

    const urls = useMemo(() => {
        const baseUrl = PRODUCT_BASE_ROUTE;

        return {
            [APP_ROUTES_KEYS.product]: (query?: IQuery) => (query?.id ? `${baseUrl}${query?.id}/` : baseUrl),
            [APP_ROUTES_KEYS.productReviews]: (query?: IQuery) =>
                query?.id ? `${baseUrl}${query?.id}/reviews/` : baseUrl,
        };
    }, []);

    return useMemo<TRouteData<TProductRoutes>>(
        // eslint-disable-next-line sort-keys
        () => urlToRouteConverter({urls, redirect}),
        [urls, redirect],
    );
};
